import { makeStyles } from "tss-react/mui";
import { constants } from "../../../constants";
export const useStyles = makeStyles()((theme) => ({
    root: {
        width: "100%",
        height: "20px",
        background: constants.color.black,
        display: "flex",
        flexDirection: "row",
        marginTop: "8px",
        gridColumn: "3 / 20",
        alignContent: "center",
        justifyContent: "space-between",
        flexWrap: "nowrap",
    },
    line: {
        border: `1px solid ${constants.color.grey20}`,
        width: "100%",
        display: "block",
        animation: "scale-in-right .5s both ease-out",

        "&.thinking": {
            border: `1px solid ${constants.color.grey20}`,
        },
        "&.error": {
            borderColor: constants.color.alizarin,
            borderWidth: "4px",
        },
        "&.success": {
            borderColor: `1px solid ${constants.color.grey20}`,
        },
        "&.collapsed": {
            display: "none",
        },
    },

    thinkingElements: {
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        "& .thinking-svg": {
            marginLeft: "24px",
            width: "16px",
            animation: "spin 1s ease-in-out infinite",
        },
        "& .thinking-copy": {
            marginLeft: "8px",
            color: constants.color.white,
            fontFamily: "Gotham Bold",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "20px",
            letterSpacing: "1.5px",
            textAlign: "left",
            textTransform: "uppercase",
        },
    },
}));
